import { isAiSubmittable } from "@features/session/constants";
import type {
	AIFeedbackResponse,
	Choice,
	ItemFeedback,
	ItemResponse,
} from "@memorang/types";
import AIExplanation from "../components/postanswer/AiExplanation";
import HumanExplanation from "../components/postanswer/HumanExplanation";
import useAIFeedbackStore from "../hooks/useAIFeedbackStore";

type Props = {
	itemId: number;
	responseType: ItemResponse["type"];
	choices: Choice[];
	persistedAiFeedback?: AIFeedbackResponse;
	feedback?: ItemFeedback;
};
const ExplanationContainer = ({
	itemId,
	responseType,
	choices,
	persistedAiFeedback,
	feedback,
}: Props) => {
	const aiResponse = useAIFeedbackStore((state) => state.aiResponse);
	const streaming = useAIFeedbackStore((state) => state.streaming);

	const isAiItemType = isAiSubmittable(responseType);

	const currentItemAiResponse = aiResponse?.[itemId] || persistedAiFeedback;

	if (isAiItemType) {
		return (
			<AIExplanation
				aiResponse={
					currentItemAiResponse?.explanation || currentItemAiResponse?.feedback
				}
				loading={streaming}
				itemId={itemId}
			/>
		);
	}

	return (
		<HumanExplanation choices={choices} itemId={itemId} feedback={feedback} />
	);
};

export default ExplanationContainer;
